import React from 'react';
import "../pages/LandingPage.css";
import facebook from "../../assets/facebook.png";
import instagram from "../../assets/instagram.png";
import twitter from "../../assets/twitter.png";
import youtube from "../../assets/youtube.png";

export default function Socials({ openInNewTab }) {
  return (
    <div className="socials">
      <div
        onClick={() =>
          openInNewTab("https://www.facebook.com/mumbaitak")
        }
      >
        <img
          src={facebook}
          alt="facebook"
          className="socialIcon"
        ></img>
      </div>
      <div
        onClick={() =>
          openInNewTab("https://twitter.com/mumbaitak")
        }
      >
        <img src={twitter} alt="twitter" className="socialIcon"></img>
      </div>
      <div
        onClick={() =>
          openInNewTab("https://www.instagram.com/mumbaitak")
        }
      >
        <img
          src={instagram}
          alt="instagram"
          className="socialIcon"
        ></img>
      </div>
      <div
        onClick={() =>
          openInNewTab("https://www.youtube.com/@MumbaiTak")
        }
      >
        <img src={youtube} alt="youtube" className="socialIcon"></img>
      </div>
    </div>
  )
}